package oldframes.triggers.categories

import bootstrap.Button
import ru.it_mozaika.utils.checkResponseError
import oldcomponents.NotyType
import oldcomponents.dropdownSelect
import oldcomponents.page.*
import oldcomponents.showNotification
import ru.it_mozaika.sender.js.application.context.UserContext
import web.cssom.ClassName
import io.ktor.client.call.*
import io.ktor.http.*
import js.core.jso
import kotlinx.html.InputType
import kotlinx.html.contentEditable
import kotlinx.html.js.onChangeFunction
import org.w3c.dom.HTMLInputElement
import react.*
import react.dom.*
import react.router.dom.Link
import react.router.useNavigate
import react.router.useParams
import ru.it_mozaika.sender.common.models.Store
import ru.it_mozaika.sender.common.models.TriggerCategory
import ru.it_mozaika.sender.common.models.UserRole
import ru.it_mozaika.sender.js.application.Http

val triggerCategoryFrame = fc<PageContentProps> { props ->
    val navigate = useNavigate()

    val params = useParams()
    val id = params["id"].orEmpty()

    var stores by useState(listOf<Store>())

    var category by useState<TriggerCategory>()
    var edit by useState(false)

    var name by useState("")
    var store by useState("")
    var mailsLimit by useState(0)
    var limitPeriod by useState(0L)
    val currentUser = useContext(UserContext).currentUser

    useEffectOnce {
        Http.get("/triggers/categories/$id") { response ->
            response.checkResponseError()?.let { error ->
                showNotification(error, NotyType.Error)
                navigate("/triggers/categories")
                return@get
            }
            category = response.body()
        }
        Http.get("/stores") { response ->
            response.checkResponseError()?.let { error ->
                showNotification(error, NotyType.Error)
                navigate("/triggers/categories")
                return@get
            }
            stores = response.body()
        }
    }
    useEffect(category) {
        name = category?.name.orEmpty()
        store = category?.store.orEmpty()
        mailsLimit = category?.mailsLimit ?: 0
        limitPeriod = category?.limitPeriod ?: 0L
    }

    child(pageContent) {
        attrs.headerProps = jso{
            header = category?.name ?: "Категория триггеров"
            breadcrumbs = listOf(
                Breadcrumb("/", "", "ti ti-home"),
                Breadcrumb("/triggers", "Триггеры", ""),
                Breadcrumb("/triggers/categories", "Категории триггеров", ""),
                Breadcrumb("/triggers/categories/$id", if (edit) "Просмотр" else "Редактирование", ""),
            )
        }
        attrs.active = props.active
        child(widget) {

            div("form-group row d-flex align-items-center mb-5") {
                label("col-lg-3 form-control-label") { +"Название:" }
                div("col-lg-9") {
                    input(InputType.text, classes = "form-control") {
                        attrs.value = name
                        attrs.contentEditable = edit
                        attrs.disabled = !edit
                        attrs.onChangeFunction = {
                            name = (it.target as? HTMLInputElement)?.value.orEmpty()
                        }
                    }
                }
            }
            div("form-group row d-flex align-items-center mb-5") {
                label("col-lg-3 form-control-label") { +"Магазин:" }
                div("col-lg-9") {
                    child(dropdownSelect) {
                        attrs {
                            dropdownOpenDefault = false
                            multiSelect = false
                            showFilter = false
                            currentValue = stores.firstOrNull { it.id == store }?.let {
                                mapOf(store to it.name)
                            } ?: mapOf()
                            selectValues = stores.map { it.id to it.name }
                            onSave = {
                                store = it.keys.firstOrNull() ?: stores.firstOrNull()?.id ?: ""
                            }
                            disabled = !edit
                        }
                    }
                }
            }

            div("form-group row d-flex align-items-center mb-5") {
                label("col-lg-3 form-control-label") { +"Ограничение кол-ва:" }
                div("col-lg-9") {
                    input(InputType.number, classes = "form-control") {
                        attrs.value = mailsLimit.toString()
                        attrs.contentEditable = edit
                        attrs.disabled = !edit
                        attrs.onChangeFunction = {
                            mailsLimit = (it.target as? HTMLInputElement)?.value?.toIntOrNull() ?: 0
                        }
                    }
                }
            }
            div("form-group row d-flex align-items-center mb-5") {
                label("col-lg-3 form-control-label") { +"Период ограничения:" }
                div("col-lg-9") {
                    input(InputType.number, classes = "form-control") {
                        attrs.value = limitPeriod.toString()
                        attrs.contentEditable = edit
                        attrs.disabled = !edit
                        attrs.onChangeFunction = {
                            limitPeriod = (it.target as? HTMLInputElement)?.value?.toLongOrNull() ?: 0
                        }
                    }
                }
            }

            div("row d-flex justify-content-end mr-2 ml-2") {
                Link {
                    attrs.to = "/triggers/categories"
                    Button {
                        attrs.type = web.html.ButtonType.button
                        attrs.variant = "shadow"
                        attrs.className = ClassName("mr-2")
                        +"Назад"
                    }
                }
                Button {
                    attrs.type = web.html.ButtonType.button
                    attrs.variant = "primary"
                    attrs.active = currentUser!!.role == UserRole.Admin
                    attrs.onClick = {
                        if (!edit) {
                            edit = true
                        } else {
                            edit = false
                            Http.post("/triggers/categories/$id", TriggerCategory(id, name, store, mailsLimit, limitPeriod)) { response ->
                                when (response.status) {
                                    HttpStatusCode.NoContent -> {
                                        showNotification("Сохранено", NotyType.Success)
                                        category = category?.copy(name = name, store = store, mailsLimit = mailsLimit, limitPeriod = limitPeriod)
                                    }
                                    HttpStatusCode.Forbidden -> { showNotification("Недостаточно прав доступа", NotyType.Error) }
                                    HttpStatusCode.BadRequest -> { showNotification("Ошибка в запросе: ${response.body<String>()}", NotyType.Error) }
                                }
                            }
                        }
                    }
                    +if (edit) {
                        "Сохранить"
                    } else {
                        "Редактировать"
                    }
                }
            }

        }
    }
}